import { Box, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon/SvgIcon';
import React, { FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';

import { useStyles } from './SidebarItem.styles';
import { NavigationMenuItem } from 'app/interfaces/sidebar';
import { StartMenuItemIcon } from 'app/components/Sidebar/StartMenuItemIcon';
import { useLocation } from 'react-router-dom';
import { EndMenuItemIcon } from 'app/components/Sidebar/EndMenuItemIcon';

interface NavigationItemProps {
  item: NavigationMenuItem;
  startIcon?: string | OverridableComponent<SvgIconTypeMap>;
  endIcon?: string | OverridableComponent<SvgIconTypeMap>;
  onClick?: (item: NavigationMenuItem) => void;
  className?: string;
}

export const SidebarItem: FC<NavigationItemProps> = ({
  item,
  startIcon,
  endIcon,
  className,
  onClick,
}) => {
  const { classes } = useStyles();
  const { pathname } = useLocation();

  const label = useMemo(
    () => (item.badge ? `${item.label} (${item.badge})` : item.label),
    [item.badge, item.label]
  );

  const isActive = useMemo(() => pathname === item?.route, [pathname, item?.route]);

  const onClickHandler = useCallback(() => {
    onClick?.(item);
  }, [onClick, item]);

  if (!item) {
    return null;
  }

  return (
    <Box
      onClick={onClickHandler}
      data-testid={item?.dataTestId ?? ''}
      className={classNames(className, classes.root, { [classes.activeContainer]: isActive })}
    >
      <Box className={classNames(classes.menuItem, { [classes.primary]: item?.isPrimary })}>
        {startIcon && <StartMenuItemIcon icon={startIcon} isActive={isActive} />}
        <Typography className={classes.label}>{label}</Typography>
        {endIcon && <EndMenuItemIcon icon={endIcon} />}
      </Box>
    </Box>
  );
};
